/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/**
 * Encodes an EE-Check time-series URN while preserving its function syntax.
 * EE-Check functions use slashes and equal signs as delimiters inside the path.
 */
export function encodeEeCheckTimeSeriesUrn(urn: string): string {
    return encodeURIComponent(urn)
        .replaceAll('%2F', '/')
        .replaceAll('%3D', '=');
}
